import { formTypes } from './types'

const imageMessageStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  border: '1px solid #ccc',
  borderRadius: '10px',
  height: '25vh',
  minHeight: '25vh',
}

const imageUploadRowStyle = {
  height: '68%',
  justifyContent: 'space-between',
  alignItems: 'center',
  maxHeight: '30vh',

  width: '25vh',
}

const textFields: {
  fieldName: formTypes
  label: string
}[] = [
  {
    fieldName: 'full_name',
    label: 'Full Name',
  },
  {
    fieldName: 'title',
    label: 'Title',
  },
  {
    fieldName: 'business_unit',
    label: 'Business Unit',
  },
  {
    fieldName: 'location',
    label: 'Location',
  },
]

const currentFormValues = {
  person_type: '',
  full_name: '',
  title: '',
  original_hire_date: '',
  business_unit: '',
  location: '',
  image: undefined,
}

const formerFormValues = {
  person_type: '',
  full_name: '',
  title: '',
  original_hire_date: '',
  termination_date: '',
  business_unit: '',
  location: '',
  image: undefined,
}

const otherFormValues = {
  person_type: '',
  full_name: '',
  description: '',
  image: undefined,
}

const recipientFormValues = {
  full_name: '',
  title: '',
  work_location: '',
  relationship_to_sender: '',
  number_of_communications: '',

}

const defaulfFormValues: { [key: string]: any } = {
  UNKNOWN: {
    person_type: '',
    description: '',
    image: undefined,
  },
  CURRENT_EMPLOYEE: currentFormValues,
  CURRENT_CONTRACTOR: currentFormValues,
  FORMER_EMPLOYEE: formerFormValues,
  FORMER_CONTRACTOR: formerFormValues,
  CUSTOMER: otherFormValues,
  CLIENT: otherFormValues,
  SUPPLIER: otherFormValues,
  PARTNER: otherFormValues,
  COMPETITOR: otherFormValues,
  LAW_ENFORCEMENT: otherFormValues,
  REGULATORY_AGENT: otherFormValues,
  UNRELATED_PARTY: otherFormValues,
  OTHER: otherFormValues,
  RECIPIENT: recipientFormValues,
}

const unknownFields: {
  fieldName: formTypes
  label: string
}[] = []

const currentFields: {
  fieldName: formTypes
  label: string
}[] = [
  {
    fieldName: 'full_name',
    label: 'Full Name',
  },
  {
    fieldName: 'title',
    label: 'Title',
  },
  {
    fieldName: 'original_hire_date',
    label: 'Original Hire Date',
  },
  {
    fieldName: 'business_unit',
    label: 'Business Unit',
  },
  {
    fieldName: 'location',
    label: 'Location',
  },
]

const formerFields: {
  fieldName: formTypes
  label: string
}[] = [
  {
    fieldName: 'full_name',
    label: 'Full Name',
  },
  {
    fieldName: 'title',
    label: 'Title',
  },
  {
    fieldName: 'original_hire_date',
    label: 'Original Hire Date',
  },
  {
    fieldName: 'termination_date',
    label: 'Termination Date',
  },
  {
    fieldName: 'business_unit',
    label: 'Business Unit',
  },
  {
    fieldName: 'location',
    label: 'Location',
  },
]

const otherFields: {
  fieldName: formTypes
  label: string
}[] = [
  {
    fieldName: 'full_name',
    label: 'Full Name (If known)',
  },
]


const recipientFields: {
  fieldName: formTypes
  label: string
}[] = [
  {
    fieldName: 'full_name',
    label: 'Full Name',
  },
  {
    fieldName: 'title',
    label: 'Title',
  },
  {
    fieldName: 'work_location',
    label: 'Work location',
  },
  {
    fieldName: 'relationship_to_sender',
    label: 'Relationship to sender',
  },
  {
    fieldName: 'number_of_communications',
    label: 'Number of communications',
  },
]

const textFieldBasedOnSubjectType: {
  [key: string]: {
    fieldName: formTypes
    label: string
  }[]
} = {
  UNKNOWN: unknownFields,
  CURRENT_EMPLOYEE: currentFields,
  CURRENT_CONTRACTOR: currentFields,
  FORMER_EMPLOYEE: formerFields,
  FORMER_CONTRACTOR: formerFields,
  CUSTOMER: otherFields,
  CLIENT: otherFields,
  SUPPLIER: otherFields,
  PARTNER: otherFields,
  COMPETITOR: otherFields,
  LAW_ENFORCEMENT: otherFields,
  REGULATORY_AGENT: otherFields,
  UNRELATED_PARTY: otherFields,
  OTHER: otherFields,
  RECIPIENT: recipientFields,
}

export default {
  imageMessageStyle,
  imageUploadRowStyle,
  defaulfFormValues,
  textFields,
  textFieldBasedOnSubjectType,
}
